import { Modal } from 'antd';
import { Button } from '../button';
import DangerIcon from '../../icons/DangerIcon.svg?react';
import CloseIcon from '../../icons/X.svg?react';
import style from './style.module.scss';

type PopupConfirmDeleteProps = {
    message: string;
    onClose: () => void;
    onOk: () => void;
};

export const PopupConfirmDelete = ({
    message,
    onClose,
    onOk,
}: PopupConfirmDeleteProps) => {
    return (
        <Modal
            open={true}
            cancelText={null}
            footer={null}
            closeIcon={<CloseIcon onClick={onClose} />}
        >
            <div className={style.modal_content}>
                <DangerIcon className={style.icon} />
                <div className={style.title}>Delete?</div>
                <div className={style.text}>{message}</div>
            </div>
            <div className={style.button_container}>
                <Button variant="secondary" onClick={onClose}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={onOk}>
                    Delete
                </Button>
            </div>
        </Modal>
    );
};
